export default {
    // 企业信息
    enterprise: r => require.ensure([], () => r(require('@/page/cw/view/enterprise/enterprise')), 'cw/enterprise'),
    //官方媒体
    official: r => require.ensure([], () => r(require('@/page/cw/view/official/official')), 'cw/official'),
    // 服务信息
    service: r => require.ensure([], () => r(require('@/page/cw/view/service/Service')), 'cw/service'),
    // 网站信息
    website: r => require.ensure([], () => r(require('@/page/cw/view/website/Website')), 'cw/website'),
    // 官网入口
    entrance: r => require.ensure([], () => r(require('@/page/cw/view/entrance/Entrance')), 'cw/entrance'),
    // 信用通栏
    banner: r => require.ensure([], () => r(require('@/page/cw/view/banner/Banner')), 'cw/banner'),
    // 网站体检
    check: r => require.ensure([], () => r(require('@/page/cw/view/check/Check')), 'cw/check'),
    // 网站备份
    backup: r => require.ensure([], () => r(require('@/page/cw/view/backup/Backup')), 'cw/backup'),
    // 网站防护
    defend: r => require.ensure([], () => r(require('@/page/cw/view/defend/Defend')), 'cw/defend'),
    defendSslCertificate: r => require.ensure([], () => r(require('@/page/cw/view/defend/sslCerfiticate')), 'cw/sslCerfiticate'),
	defendChilddomain: r => require.ensure([], () => r(require('@/page/cw/view/defend/childDomainManage')), 'cw/childDomainManage'),
    // 账号设置
    set: r => require.ensure([], () => r(require('@/page/cw/view/set/Set')), 'cw/set'),
    // 小程序
    miniprogram: r => require.ensure([], () => r(require('@/page/cw/view/miniprogram/Miniprogram')), 'cw/miniprogram'),
    // 主体
    content: r => require.ensure([], () => r(require('@/page/cw/view/Content')), 'cw/content'),
    // 安全服务
    safeService: r => require.ensure([], () => r(require('@/page/cw/view/safeService/SafeService')), 'cw/safeService'),

    //编辑官方媒体
    officialEdit: r => require.ensure([], () => r(require('@/page/cw/view/officialEdit/officialEdit')), 'cw/officialEdit'),
    //编辑企业信息
    enterpriseEdit: r => require.ensure([], () => r(require('@/page/cw/view/enterpriseEdit/enterpriseEdit')), 'cw/enterpriseEdit'),
    // ssl证书
    sslEdit: r => require.ensure([], () => r(require('@/page/cw/view/sslEdit')), 'cw/sslEdit'),
    // 新版ssl证书
    newSsl: r => require.ensure([], () => r(require('@/page/cw/view/newSsl')), 'cw/newSsl'),
    // 新版新增网站检测
    newWebCheck: r => require.ensure([], () => r(require('@/page/cw/view/newWebCheck/Check')), 'cw/newWebCheck'),
    newSslDetail: r => require.ensure([], () => r(require('@/page/cw/view/newSsl/detail.vue')), 'cw/newSslapply')
}



// WEBPACK FOOTER //
// ./src/page/cw/router/fullpath.js